import React, { useCallback } from "react";

import { ModalFooter, ModalBody, ModalHeader, Modal } from "reactstrap";

import { withTranslation } from "react-i18next";
import Button from "../Button";

const ConfirmModal = ({
  onConfirm,
  onCancel,
  message,
  title,
  isOpen,
  onClose,
  t,
}) => {
  const handleConfirm = useCallback(() => onConfirm(), [onConfirm]);
  const handleCancel = useCallback(() => onCancel(), [onCancel]);
  const handleClose = useCallback(() => onClose(), [onClose]);

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <ModalHeader
        className="modal-header-no-button px-4 pt-4 border-bottom-0"
        toggle={handleClose}
      >
        {title}
      </ModalHeader>
      <ModalBody className="px-4">{message}</ModalBody>
      <ModalFooter className="px-4 pb-4">
        <Button variant="outlined" className="w-auto" onClick={handleCancel}>
          {t("Cancel")}
        </Button>

        <button
          onClick={handleConfirm}
          color="primary"
          className="btn btn-primary mb-2"
        >
          {t("Confirm")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default withTranslation()(ConfirmModal);
